import React from "react";
import { Skeleton } from "./shared/Skeleton";

const Splash = () => (
  <div style={{ minHeight: "100vh", background: "var(--at-bg)" }}>
    <Skeleton height={72} radius={0} />
    <div className="at-page-content">
      <Skeleton height={200} className="mb-4" />
      <Skeleton height={28} width={280} className="mb-3" />
      <div className="d-flex flex-wrap gap-3">
        <Skeleton height={220} style={{ flex: "1 1 260px" }} />
        <Skeleton height={220} style={{ flex: "1 1 260px" }} />
        <Skeleton height={220} style={{ flex: "1 1 260px" }} />
      </div>
    </div>
  </div>
);

export default Splash;
